import '../../immer-init';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'broadcastchannel-polyfill';
import '../../styles';
import { store } from './json-view-store';
import history from '../../history';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { Route, Switch } from 'react-router-dom';
import JsonViewApp from './json-view-component';
import { authenticationChannelReceiverFactory } from '../../core/middleware/authentication-channel-middleware';
import { buildSubscriptions as buildChannelSubscriptions } from '../pop-up/case-channel-subscriptions';
// eslint-disable-next-line
import { authenticationChannel } from '@codametrix/ui-common';

const currentURL = new URL(`${window?.top?.location}`);
const subscriptions = buildChannelSubscriptions(currentURL);

authenticationChannelReceiverFactory(subscriptions, store);

const App = () => {
  return (
    <Provider store={store}>
      <Router history={history}>
        <Switch>
          <Route path="/" component={JsonViewApp} />
        </Switch>
      </Router>
    </Provider>
  );
};

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(<App />);
